export default {
  COLLECTION_TYPE_SEASONAL: 'seasonal',
  COLLECTION_TYPE_TIMELESS: 'timeless',
};
